import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "app/store";
import { Spin } from "common/elements";
import { ScreenModalProvider } from "features/builder/elements";
import { savePieceContentThrottled } from "features/builder/slice";
import { Canvas } from "./Canvas";

export const MapMaker = () => {
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector((state: RootState) => state.builder.loading);
  // 編集中マップの変更を 5 秒スロットルで /v1/pieces/:id/content に自動保存（thunk 内でガード）
  const mapState = useSelector((state: RootState) => state.builder.map);
  const size = useSelector((state: RootState) => state.builder.size);
  const firstRun = useRef(true);
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    dispatch(savePieceContentThrottled());
  }, [mapState, size, dispatch]);

  return (
    <div className="flex-col-center relative w-full h-full bg-[rgba(0,0,0,0.67)]">
      {loading && <Spin />}
      {/* Modal は倍率つきの全画面の層に出る（編集画面は部品ごとに scale を当てる作りで、外側に scale が無い） */}
      <ScreenModalProvider>
        <Canvas />
      </ScreenModalProvider>
    </div>
  );
};
